<template>
  <div class="abouts">
    <div class="main-banner" :style="'background-image: url('+bannerList+');'">
    	<div class="banner-title">
    		<h2>关于我们</h2>
    		<h3>About us</h3>
    	</div>
    </div>
    <div class="container">
			<div class="profile">
				<div class="title">
					<h2>公司简介</h2>
					<h3>Company profile</h3>
				</div>
				<div class="main">
					<div class="left wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
						<img src="../../assets/about01.jpg" alt="">
					</div>
					<div class="right">
						<p v-for="item in $t('about.details')" :style="imgClass" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">{{item.text}}</p>
					</div>
				</div>
			</div>
			<div class="honor">
				<div class="title">
					<h2>公司荣誉</h2>
					<h3>Company honor</h3>
				</div>
				<div class="honorNav">
					<div v-for="item in $t('honor.nav')" :class="item.id==typeId?'active':''"  :key="item.id" @click="honorClick(item.id)">{{item.name}}</div>
				</div>
				<ul>
					<li v-for="item in honorList" @click="open($event)" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
            <div><img :src="item.pic" :alt="$AppLang == 'en' ? item.content_en :item.content"></div>
            <h6>{{$AppLang == 'en' ? item.content_en :item.content}}</h6>
          </li>
				</ul>
			</div>
			<el-pagination
				background layout="prev, pager, next"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:total="pageCount">
			</el-pagination>
		</div>
		<el-dialog title="" :visible.sync="centerDialogVisible" width="80%" center>
			<img :src="honorImgSrc" style="width: auto;max-width: 100%;margin: 0 auto;">
      <p style="text-align: center;margin-top: 20px;">{{honorTitle}}</p>
		</el-dialog>
  </div>
</template>

<script>
  export default {
  	name: 'about',
  	data() {
  		return {
				centerDialogVisible : false,
				bannerList: [],
				honorImgSrc : '',
        honorTitle : '',
				honorList: [],
				typeId: 1,
				pageStart: 1,
				pageTotal: 6,
				pageCount: 50,
        imgClass: ""
  		};
  	},
    created() {
      var lang =  sessionStorage.getItem('locale');
      var imgClass = "";
      if (lang == "en") {
        imgClass = {"line-height": 1.3,"font-size": "12px"}
      } else{
        imgClass = "";
      }
      this.imgClass = imgClass;
    },
		mounted() {
			this.honorPage();
			this.bannerApi();
		},
		methods: {
      open(event) {
				this.centerDialogVisible = true;
				this.honorImgSrc = event.toElement.src;
        this.honorTitle = event.toElement.alt;
				console.log(event);
      },
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.pageStart = val;
				this.honorPage();
				//console.log(`当前页: ${val}`);
			},
			honorClick(e){
				this.typeId = e;
				// this.pageStart = 1;
				// console.log(this.pageStart+",123");
				this.honorPage();
			},
			honorPage(){
				var that = this;
        var options={ live:false};
				//荣誉专利列表请求接口
				that.$api.post(
					'/honor/websiteHonor',
					{
						type: that.typeId,
						pageStart: that.pageStart,
						pageTotal: that.pageTotal
					},
					function(res) {
						if(res.data.rtnCode == 200){
							var list = res.data.data;
							that.honorList = list.data;
							that.pageCount = list.pageCount;
              that.$nextTick(function(){
              	var wow=new that.$wow.WOW(options).init();
              });
						}else{
							alert(res.data.msg);
						}
					}
				);
			},
			bannerApi(){
				var that = this;
				//banner请求接口
				that.$api.post(
					'banner/websiteBanners',
					{
						type: 4
					},
					function(res) {
						if(res.data.rtnCode == 200){
							var list = res.data.data;
							for(var i=0;i<list.length;i++){
								if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))){
									list[i].banner = list[i].phone_banner;
								}else{
									list[i].banner = list[i].pic;
								}
							}
							that.bannerList = list[0].banner;
						}else{
							alert(res.data.msg);
						}
					}
				);
			}
    },
    metaInfo: {
      title: '佛山鼎吉-关于我们', // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: '鼎吉,鼎吉官网,陶瓷墙地砖拣选包装自动化设备,研发、设计、制造、安装为一体的高新技术型企业,佛山市鼎吉包装技术有限公司'
      },
      { // set meta
        name: 'description',
        content: '佛山市鼎吉包装技术有限公司成立于2008年,是一家集研发、设计、制造、安装为一体的高新技术型企业。专业致力于研发生产陶瓷墙地砖拣选包装自动化设备。公司遵循“以市场为导向、以研发为动力、以质量为核心竞争力”的发展宗旨服务建陶企业，为建陶产业的生产自动化和可持续发展做贡献。'
      }],
      link: [{ // set link
        rel: 'asstes',
        href: 'https://www.dinovor.com/'
      }]
    }
  }
</script>

<style>
.abouts{
	background: #f5f5f5;
	padding-bottom: 50px;
}
.abouts .el-dialog{
	min-height: 80vh;
	margin-top: 10vh !important;
	display: grid;
}

.abouts .main-banner{
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}
.abouts .container .title{
	padding-top: 80px;
	padding-bottom: 20px;
	margin-bottom: 60px;
	/* border-bottom: 1px solid #e3e3e3; */
}
.abouts .container .title h2,.abouts .container .title h3{
	text-align: center;
}
.profile .main{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.profile .main .left{
	width: 50%;
}
.profile .main .right{
	width: 50%;
	padding: 2%;
	box-sizing: border-box;
	background: #f2f2f2;
}
.profile .main .right p{
	text-align: justify;
	font-size: 14px;
	color: #999;
	line-height: 24px;
	margin-bottom: 10px;
}
.honor .honorNav{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 60px;
}
.honor .honorNav div{
	padding: 6px  26px;
	margin-left: 3px;
	color: #717171;
	font-size: 14px;
	transition: all .5s ease;
  cursor: pointer;
}
.honor .honorNav div::before{
  content: "|";
  position: relative;
  top: 0;
  left: -29px;
  color: #e2e2e2;
}
.honor .honorNav div:first-child::before{
  display: none;
}
.honor .honorNav div:hover{
  background-color: #333;
  color: rgba(255,255,255,.62);
}
.honor .honorNav div.active{
  background-color: #333;
  color: rgba(255,255,255,.62);
}
.honor{
	margin-bottom: 60px;
}
.honor ul{
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
}
.honor ul li{
  width: 32%;
  background-color: #fff;
	padding: 30px;
	box-sizing: border-box;
	position: relative;
	margin-bottom: 40px;
  cursor: pointer;
  transition: all .5s ease;
}
.honor ul li div{
  width: 100%;
  /* height: 245px; */
  overflow: hidden;
}
.honor ul li div img{
  transition: all .5s ease;
}
.honor ul li h6{
  font-size: 14px;
  text-align: center;
  color: #6b6b6b;
  margin-top: 10px;
}
.honor ul li:hover{
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.4);
}
.honor ul li:hover img{
  transform: scale(1.1);
}
.abouts .el-pagination{
	text-align: right;
}
.abouts .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #333;
	color: rgba(255,255,255,.62);
}
@media (max-width: 992px){
  .abouts{
    padding-top: 0;
  }
  .abouts .container .title h2{
    font-size: 20px;
  }
  .profile .main{
    flex-wrap: wrap;
  }
  .profile .main .left,.profile .main .right{
  	width: 100%;
  }
  .profile .main .right{
    margin-top: 20px;
    background: none;
  }
	.honor .honorNav{
		justify-content: center;
	}
  .honor ul li{
    width: 48%;
		padding: 5px;
  }
  .honor ul li div{
    width: 100%;
    height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/about.vue